import { Alert, Snackbar } from "@mui/material"
import React, { useCallback, useState } from "react"
import { Children } from "@app/core/type/Children"

export const WarningContext = React.createContext<(message: string) => void>(() => {
  // do nothing, function will be set later
})

export default function WarningSnackbar({ children }: Readonly<Children>): React.JSX.Element {
  const [msg, setMsg] = useState<string | undefined>(undefined)
  const [open, setOpen] = useState<boolean>(false)

  function handleClose(): void {
    setMsg(undefined)
    setOpen(false)
  }

  const openWarningSnackbar = useCallback((message: string) => {
    setMsg(message)
    setOpen(true)
  }, [])

  return (
    <WarningContext.Provider value={openWarningSnackbar}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={8000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert onClose={handleClose} severity="warning" variant="filled" sx={{ width: "100%" }}>
          {msg}
        </Alert>
      </Snackbar>
    </WarningContext.Provider>
  )
}
